import moment from 'moment-timezone';

import { DATE_TIME_FORMAT } from '../../../constants';
import { applyServerTimezone, getFormattedPhoneNumber } from '../../../helpers';

const getFormattedDate = (date, time) =>
  moment(
    `${moment(date).utc().format(DATE_TIME_FORMAT.YYYY_MM_DD_DASH)} ${time}`,
    'YYYY-MM-DD hh:mm A',
  );

export const getFormattedReports = reports =>
  reports.map(v => {
    const scheduledDate = getFormattedDate(
      v.SDRDateBookedFor,
      v.SDRTimeBookedFor,
    ).format(DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A);
    const contactTitle = v.ContactTitle || '';
    const phoneNumber = getFormattedPhoneNumber(
      v.ConnectedPhoneNumber || v.BestPhoneNumber,
    );
    const email = v.Email || '';
    const hasRescheduledBookingDate =
      !!v.SDRRescheduledDate && !!v.SDRRescheduledTime;
    const rescheduledDate = hasRescheduledBookingDate
      ? getFormattedDate(v.SDRRescheduledDate, v.SDRRescheduledTime).format(
          DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A,
        )
      : '';
    const createdAt = moment(applyServerTimezone(v.TimeStampOfBooking)).format(
      DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A,
    );

    return {
      apptID: v.ApptID,
      apptType: v.ApptType,
      companyName: v.CompanyName,
      contactName: v.ContactName,
      contactTitle,
      createdAt,
      email,
      fullName: v.FullName,
      leadID: v.LeadID,
      phoneNumber,
      rescheduledDate,
      scheduledDate,
      status: v.Status,
      tenantName: v.TenantName,
    };
  });
